module.exports = __webpack_public_path__ + "img/memberCrown.be34e951.svg";